import React from 'react';
import { ModalContainer } from '../components/ModalContainer';
import { Content, FooterWrapper, Header } from './styles';
import Message from 'src/components/Modals/SessionTimeout/Message';
import i18next, { t } from 'i18next';
import { TitleContainer } from 'src/components/Modals/SessionTimeout/styles';
import Footer from 'src/components/Modals/SessionTimeout/Footer';
import { AccessibleDialog } from '../components';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import MvpSessionTimeout from 'src/components/Modals/SessionTimeout/MvpSessionTimeout';

interface ISessionTimeoutDialog {
  onConfirm?: () => void;
  onCancel?: () => void;
  onCountdownComplete: () => void;
  timeout: number;
}

const SessionTimeoutDialog = ({
  onCancel,
  onConfirm,
  timeout,
  onCountdownComplete,
}: ISessionTimeoutDialog) => {
  const isFromMvpApp = useUrlParameterCheck('/app');

  return (
    <AccessibleDialog
      onConfirm={onConfirm}
      onCancel={onCancel}
      ariaLabel={t('SessionExpirationMessage')}
    >
      {isFromMvpApp ? (
        <MvpSessionTimeout
          timeout={timeout}
          onCountdownComplete={onCountdownComplete}
          onCancel={onCancel}
          onConfirm={onConfirm}
          title={i18next.t('SessionTimeout')}
        />
      ) : (
        <ModalContainer aria-modal="true" aria-live="off" width={360}>
          <div
            style={
              isFromMvpApp ? { display: 'flex', flexDirection: 'column' } : {}
            }
          >
            <Header>
              <TitleContainer>{t('SessionTimeout')}</TitleContainer>
            </Header>
            <Content>
              <Message
                timeout={timeout}
                onCountdownComplete={onCountdownComplete}
              />
            </Content>
            <FooterWrapper>
              <Footer onConfirm={onConfirm} onCancel={onCancel} />
            </FooterWrapper>
          </div>
        </ModalContainer>
      )}
    </AccessibleDialog>
  );
};

export default SessionTimeoutDialog;
